// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3b9bb3db","455":"8cb8c190","977":"730f414e"}[chunkId] + ".chunk.js";
};